import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Col, Form, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import PaginationTop from "./PaginationTop";
import SearchInput from "./input/SearchInput";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import {parseDate} from "enqc-utilities/src/utils/Utilities";

export default class ModelFilterModal extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            selectedModels:new Set([]),
            selectedModelCategories:new Set([]),
            search:"",
            models:[],
            model:{},
            sortOption:{},
            page:1,
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            show:false
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    addModelSelectedId(object){
        let {selectedModels} = this.state
        selectedModels.add(object)
        this.setState({selectedModels})
    }

    removeModelSelectedId(object){
        let {selectedModels} = this.state
        let objectToDelete = undefined ;
        selectedModels.forEach((item)=>{
            if(item.id===object.id){
                objectToDelete = item
            }
        })
        if(objectToDelete){
            selectedModels.delete(objectToDelete)
        }
        this.setState({selectedModels})
    }

    exists(object){
        let {selectedModels} = this.state
        let has = false ;
        selectedModels.forEach((item)=>{
            if(item.id===object.id){
                has = true
            }
        })
        return has
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let prevState = this.state
            let show = nextProps.show?nextProps.show:false
            let selectedModels = nextProps.selectedModels?nextProps.selectedModels:new Set([])
            let selectedModelCategories = nextProps.selectedModelCategories?nextProps.selectedModelCategories:new Set([])
            let search = this.state.search
            if(show && !prevState.show){
                search = ''
            }
            this.setState({show, selectedModels, selectedModelCategories, search},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                    this.fetchModels()
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }

    }

    fetchModels(){
        let {model, selectedModelCategories, sortOption, search} = this.state
        let modelCategoryIds = []
        if(selectedModelCategories){
            modelCategoryIds = new Array()
            selectedModelCategories.forEach((item)=>{
                modelCategoryIds.push(item.id)
            })
        }

        this.get(Endpoint.API.MODELS, {
            params :{
                ascending: sortOption.ascending,
                sortir: sortOption.sortir,
                page: this.state.page - 1,
                modelCategoryIds:modelCategoryIds.join(","),
                search:search
            }
        }, null, response=>{
            if(response.code===200){
                let models = response.data
                let totalPage = response.totalPage
                let totalElement = response.totalElement
                let pageElement = response.pageElement
                this.setState({models:models,totalPage, totalElement, pageElement})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    onSelect(model){
        if(this.props.onSelect){
            this.props.onSelect(model);
        }
    }




    render() {
        let {models,show, selectedModels, selectedModelCategories, page,totalPage, totalElement, pageElement} = this.state
        let titleDescription = "";
        if(selectedModelCategories.size === 1){
            titleDescription = label.Of_Size_ModelCategory(selectedModelCategories.size)
        }else if(selectedModelCategories.size > 1){
            titleDescription = label.Of_Size_ModelCategories(selectedModelCategories.size)
        }
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">
                            {label.SelectModel}&nbsp;{titleDescription}
                        </Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={4} className="mb-3">
                                <SearchInput
                                    onEnter={(search) => {
                                        this.setState({search, page:1}, () => {
                                            this.fetchModels()
                                        })
                                    }} onEmpty={() => {
                                    this.setState({search:"", page:1}, () => {
                                        this.fetchModels()
                                    })
                                }}/>
                            </Col>
                            <Col md={8} className="text-right mb-3">
                                <PaginationTop
                                    onSelect={(page) => {
                                        this.setState({page}, () => {
                                            this.fetchModels()
                                        })
                                    }}
                                    currentPage={page}
                                    pageCount={totalPage}
                                    totalElement={totalElement}
                                    showingRow={page}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className="table-sm align-items-center table-flush p-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col" className="text-center" style={{width:'10%'}}>#</th>
                                        <th scope="col" style={{width:'70%'}}>{label.ModelInformation}</th>
                                        <th scope="col" className="text-center">{label.Select}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {models.map((item, index) => {
                                        return (
                                            <tr>
                                                <th className="text-center" scope="row" style={{width:'10%'}}>
                                                    #{((page - 1) * pageElement) + (index+1)}
                                                </th>
                                                <td scope="row" className="text-wrap" style={{width:'70%'}}>
                                                    <span>{item.name}</span>
                                                    <br/>
                                                    <span>{label.PN}:</span>&nbsp;<span>{item.partNumber}</span>
                                                </td>
                                                <td scope="col" className="text-center">
                                                    <Form.Check
                                                        size="lg"
                                                        id="checkbox1"
                                                        htmlFor="checkbox1"
                                                        checked={this.exists(item)}
                                                        onChange={event => {
                                                            if(this.exists(item)){
                                                                this.removeModelSelectedId(item)
                                                            }else{
                                                                this.addModelSelectedId(item)
                                                            }
                                                        }}
                                                        className="pl-3"
                                                        label="" />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            size="sm"
                            variant="success"
                            onClick={event => {
                                let selectedModels = new Set([])
                                this.setState({
                                    selectedModels
                                }, () => {
                                    this.props.onSelect(selectedModels)
                                })
                            }}>
                            {label.ResetFilter}
                        </Button>
                        <Button
                            variant="info"
                            size="sm"
                            onClick={event => {
                                this.props.onSelect(selectedModels)
                            }}>
                            {label.ApplyFilter}
                            &nbsp;
                            {label.Selected_Count(selectedModels.size?selectedModels.size:0)}
                            &nbsp;
                            <FontAwesomeIcon size="sm" icon={faFilter} />
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

}
ModelFilterModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func.isRequired,
    selectedModels:PropTypes.any,
    selectedModelCategories:PropTypes.any

}
